import React, { useState } from 'react';
import { Magic } from 'magic-sdk';
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { api } from '../services/api'
import './Auth.css'; // Import the CSS for styling

const magic = new Magic(import.meta.env.VITE_MAGIC_API_KEY); // Replace with your Magic key

const Auth: React.FC = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {

      // Trigger Magic's OTP email login
      const didToken = await magic.auth.loginWithEmailOTP({ email });

      // Send the DID token to your backend for verification
      const response = await api.post('/auth/login', { didToken });

      // Store the JWT received from the backend in localStorage
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token); // Save JWT in localStorage

        // Decode the JWT to access user info
        const decoded: any = jwtDecode(response.data.token);

        // Set the JWT in axios headers for future requests
        api.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;

        // Navigate based on whether the user is new or existing
        // Redirect based on kycStatus
        if (decoded.kycStatus === 'pending') {
          navigate('/kyc');
        } else if (decoded.kycStatus === 'accepted') {
          navigate('/');
        } else {
          // Handle other statuses if necessary
          navigate('/');
        }
      } else {
        throw new Error('Token not found in the response.');
      }
    } catch (error) {
      console.error('Error during login:', error);
      setError('Authentication failed, please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-box">
        <h2>Login</h2>
        <form onSubmit={handleLogin}>
          <label htmlFor="email" className="auth-label">Email:</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="auth-input"
            required
          />
          {loading ? (
            <p className="auth-loading">Sending OTP...</p>
          ) : (
            <button type="submit" className="auth-button">Send OTP</button>
          )}
          {error && <p className="error-message">{error}</p>}
        </form>
      </div>
    </div>
  );
};

export default Auth;
